import { addQuotes } from '../utils/smartutils';

export function schoolReportSaveMutation(values, status) {
  const formattedData = (data) => {
    return data.map((item) => ({
      id: 0,
      frequency: item.frequency,
      average: item.average,
      absences: item.absences,
      subject: {
        id: item.id,
        termFilterId: 0,
        filterByStatus: false,
        updaterId: 0,
        subjectLevelFilterId: 0,
        active: true,
      },
    }));
  };

  const schoolReport = values.reportCardWrapper.students.map((student) => ({
    id: student.reportId || 0,
    cycleEndingId: values.closure.id,
    student: {
      id: student.id,
      updaterId: 0,
      active: true,
      activeOnLoggedPeriod: true,
      legacyId: 0,
      dateOfBirth: 0,
    },
    schoolClass: {
      id: values.selectedSchoolClass.id,
      term: {
        id: values.closure.period.id,
        finalDate: 0,
        updaterId: 0,
        year: 0,
        initialDate: 0,
      },
      courseStep: values.closure.courseStep,
      year: 0,
      updaterId: 0,
      active: true,
      studentsQuantity: 0,
    },
    cycleNumber: values.closure.cycleNumber,
    schoolReportItems: formattedData(student.data),
  }));

  return `mutation{
    schoolReportSave(
        status: ${addQuotes(status)}
        schoolReport: ${JSON.stringify(schoolReport).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}
    )
    {
        id, 
    }
}`;
}

export function listSchoolReportForPrint(classId, cycleNumber) {
  return `{
    schoolReportListByClassAndCycle(classId:${classId}, cycleNumber:${cycleNumber})
    {
      id
      student{
        value
        label
      }
    }
  }`;
}

export function schoolReportRemoveMutation(dataToRemove) {
  return `
  mutation {
      schoolReportRemove(schoolReport: ${JSON.stringify(dataToRemove).replace(
        /"([^(")"]+)":/g,
        '$1:'
      )})
    }
  `;
}
